import React from 'react'
import { connect } from 'react-redux'
import withSizes from 'react-sizes'
import { bool } from 'prop-types'
import Draw from './DrawControl'

const MapTools = ({
  drawEnabled,
  isMobile,
  listShow,
  cycloramaShow,
  streetViewShow,
  ie,
}) =>
  drawEnabled &&
  !isMobile &&
  !listShow &&
  !cycloramaShow &&
  !streetViewShow &&
  !ie ? (
    <Draw />
  ) : null

MapTools.propTypes = {
  drawEnabled: bool.isRequired,
  isMobile: bool.isRequired,
  listShow: bool.isRequired,
  ie: bool.isRequired,
}

const mapStateToProps = ({ spi, ui }) => ({
  drawEnabled: spi.drawEnabled,
  listShow: ui.listShow,
  cycloramaShow: ui.cycloramaShow,
  streetViewShow: ui.streetViewShow,
  ie: ui.ie,
})

const mapSizesToProps = ({ width }) => ({
  isMobile: width <= 770,
})

export default withSizes(mapSizesToProps)(connect(mapStateToProps)(MapTools))



// WEBPACK FOOTER //
// ./src/components/Map/MapTools/index.jsx